(function () {
  'use strict';

  angular
      .module('tfc.sso')
      .controller('PasswordResetFormCtrl', PasswordResetFormCtrl)
      .directive('tfcPasswordResetForm', tfcPasswordResetForm);

  // @ngInject
  function PasswordResetFormCtrl(Auth) {
    var vm = this;

    vm.isAuthenticated = function () {
      return !!Auth.getUser();
    };
  }

  // @ngInject
  function tfcPasswordResetForm() {
    return {
      bindToController : true,
      controller : 'PasswordResetFormCtrl as vm',
      templateUrl : 'sso/PasswordResetForm.tmpl.html',
      scope : {
        user : '=',
        onSubmit : '&'
      }
    };
  }

})();
